import { useState } from 'react';
import { BlockWrapper } from '@smartfire/js-block-engine';
import { useMediaQuery } from '@mui/material';
import { PlusButton } from '../components';
import PictoTrophee from './PictoTrophee';
import style from './block.module.scss';

const Block = ({ player, allClubsUrl }) => {
    const [showClubAchievements, setShowClubAchievements] = useState(
        player.clubAchievements && player.clubAchievements.length,
    );
    const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);
    const mobileImg = player.thumbnailUrl ?? player.bannerUrl ?? null;
    const desktopImg = player.bannerUrl ?? player.thumbnailUrl ?? null;
    const hasAchievements = player.clubAchievements || player.internationalAchievements;

    // Manage display of picto
    const hideClubPicto = false;
    const hideInterPicto = false;
    // const hasNoPictoTrophee = (achvt) => !achvt.club_image_select;
    // const hideClubPicto = player.clubAchievements && player.clubAchievements.every(hasNoPictoTrophee);
    // const hideInterPicto =
    //     player.internationalAchievements && player.internationalAchievements.every(hasNoPictoTrophee);

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.top} style={{ backgroundImage: `url(${isMobile ? mobileImg : desktopImg})` }}>
                <div>
                    <h1>{player.name}</h1>

                    <div className={style.playerInfo}>
                        <div key="position">{player.playingPosition}</div>
                        <div key="selections">{player.nbSelections} SÉLECTIONS</div>
                        <div key="goals">{player.nbGoals} BUTS</div>
                    </div>
                </div>
            </div>

            <div className={style.clubs}>
                <h2 key="clubsHistory">Clubs précédents</h2>

                {player.clubs ? (
                    <ul>
                        {player.clubs.map((club) => (
                            <li key={club.id || `club-${club.club_name}-${club.period_club}`}>
                                <div className={style.clubName}>{club.club_name}</div>
                                <div className={style.periodClub}>{club.period_club}</div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div key="no-clubs">Aucun club enregistré...</div>
                )}

                {allClubsUrl && <PlusButton key="allClubs" link={allClubsUrl} text="TOUS LES CLUBS" classNames={style.button} />}
            </div>

            {hasAchievements && (
                <div className={style.achievements}>
                    <div className={style.achievementSelector}>
                        {player.clubAchievements && (
                            <div
                                key="club-achievements-selector"
                                className={showClubAchievements ? style.active : undefined}
                                onClick={() => setShowClubAchievements(true)}
                            >
                                Palmarès en club
                            </div>
                        )}
                        {player.internationalAchievements && (
                            <div
                                key="international-achievements-selector"
                                className={!showClubAchievements ? style.active : undefined}
                                onClick={() => setShowClubAchievements(false)}
                            >
                                Palmarès internationnal
                            </div>
                        )}
                    </div>

                    {showClubAchievements ? (
                        <div key="club-achievements-container">
                            {player.clubAchievements && (
                                <ul>
                                    {player.clubAchievements.map((achievement, i) => (
                                        <li key={`club-achievement-${i}-${achievement.club_achievement}`} className={style.achievement}>
                                            {!hideClubPicto && <PictoTrophee src={achievement.club_image_select} />}

                                            <span className={style.periodAchievement}>
                                                {achievement.period_club_achievement}
                                            </span>

                                            <span className={style.name}>&nbsp;- {achievement.club_achievement}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : (
                        <div key="international-achievements-container">
                            {player.internationalAchievements && (
                                <ul>
                                    {player.internationalAchievements.map((achievement, i) => (
                                        <li key={`international-achievement-${i}-${achievement.international_achievement}`} className={style.achievement}>
                                            {!hideInterPicto && <PictoTrophee src={achievement.club_image_select} />}

                                            <span className={style.periodAchievement}>
                                                {achievement.period_international_achievement}
                                            </span>

                                            <span className={style.name}>
                                                &nbsp;- {achievement.international_achievement}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                </div>
            )}
        </BlockWrapper.Div>
    );
};

export default Block;
